import { Dialog, DialogFooter, DialogType } from '@fluentui/react';
import React, { useEffect, useState } from 'react';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { BwjButton, BwjButtonType } from '../../../../framework/components/bwj-button';

xlationContext('Trial/subscription expired alert modal');

export interface IShowManageSubscriptionModalArgs {
  trialSubscription: boolean;
}

export interface IManageSubscriptionModalProps {
  showModalArgs: IShowManageSubscriptionModalArgs | undefined;
}

const componentStyles = {
  main: {
    maxWidth: 450,
  }
}

export const ManageSubscriptionModal: React.FunctionComponent<IManageSubscriptionModalProps> = (props) => {
  const [hideDialog, setHideDialog] = useState(true);
  const { showModalArgs } = props;

  useEffect(() => {
    setHideDialog(showModalArgs === undefined);
  }, [showModalArgs]);

  const onManageSubscription = () => {
    setHideDialog(true);
    // TODO: go to manage my subscription page
  };

  const onDismiss = () => setHideDialog(true);

  const trialSubscription = showModalArgs?.trialSubscription ?? false;
  const title = trialSubscription ?
  xlate('Trial Subscription Ended')
  : xlate('Subscription Status Change');

  const message = trialSubscription ?
  xlate('If you\'ve found Presentual useful, please join us! Use the button below to choose the plan that best fits your needs, and enjoy continued access to our best-in-class discussion planning tools.')
  : xlate('A change occurred with the status of your subscription that will impact your ability to use Presentual.  To address this matter, please visit the Manage My Subscription page.');

  const buttonText = trialSubscription ?
  xlate('Subscribe to Presentual')
  : xlate('Go to Manage My Subscription');


  return (
    <Dialog
      hidden={hideDialog}
      dialogContentProps={{
        type: DialogType.normal,
        title: title,
        subText: message,
        showCloseButton: true,
        closeButtonAriaLabel: xlate('Close dialog'),
        onDismiss: onDismiss,
      }}
      modalProps={{
        isBlocking: true,
        styles: componentStyles,
      }}
    >
      <DialogFooter
        styles={{ actionsRight: { textAlign: 'center', marginRight: 0 }}}
      >
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={buttonText}
          onClick={onManageSubscription}
        />
      </DialogFooter>
    </Dialog>
  );
};
